/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from '../style'
import React from 'react'
import { ChartTable } from '../../treasury-chart'

export default () => {
    return (<React.Fragment>
    <div id="charts" className="vertical-offset-sm"></div>
    <div data-name="overview-charts" className="container vertical-offset-sm" css={sectionCss}>
        <div className="row vertical-offset-sm"></div>
        <div className="row">
        <div className="col-md-12 col-xs-12">
            <h3 className="medium-header">Charts</h3>
        </div>
        </div>

        <ChartTable />
    </div>
    </React.Fragment>)
}



// WEBPACK FOOTER //
// ./src/overview/yield-charts/yield-charts.js